import { forecastFrequency } from "@redotech/redo-inventory-common/forecast-frequency";
import { plainDate } from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const ForecastAdjustmentEntrySchema = z.object({
  sku: z.string().min(1),
  frequency: createEnum(forecastFrequency),
  date: plainDate(),
  adjustment: z.number().int(),
});
export type ForecastAdjustmentEntry = z.infer<
  typeof ForecastAdjustmentEntrySchema
>;

export const upsertForecastAdjustmentsForPeriod = {
  name: "upsertForecastAdjustmentsForPeriod" as const,
  input: z.object({
    adjustments: z.array(ForecastAdjustmentEntrySchema).min(1).max(2000),
  }),
  output: z.object({
    results: z.array(
      z.object({ sku: z.string(), date: plainDate(), success: z.boolean() }),
    ),
  }),
};
